import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_22: DocMigration = {
  maxSchemaVersion: "0.0.22",
  apply(json: any) {
    if (json.viewerFilter) {
      json.viewerFilter.electrical = true;
    }
    return json;
  },
};

export default migration_0_0_22;
